import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import {connect} from 'react-redux';

import {ENUMS} from 'js/common';
import AgeEntry from 'js/components/smart_question/defaults/age_entry';
import GenderSelect from 'js/components/smart_question/defaults/gender_select';
import FormChildren from 'js/form_components/form_children';

import {track} from 'js/common/analytics';

import SmartQuestion from 'js/execution/v2/panels/smart_questions_panel/shared_proptypes/smart_question';

import AnswerStrategy from './answer_strategy';
import AgreementAnswerer from './agreement';

class Form extends Component {
    static propTypes = {
        currentResult: PropTypes.bool,
        questions: PropTypes.arrayOf(SmartQuestion).isRequired,
        answers: PropTypes.object,
        handleAnswerGiven: PropTypes.func.isRequired,
        user: PropTypes.shape({email: PropTypes.string.isRequired})
    };

    UNSAFE_componentWillMount() {
        const {user, currentResult} = this.props;

        if (user && R.isNil(currentResult)) {
            track(user.email, 'Viewed Smart Question', {});
        }
    }

    render() {
        const {currentResult, questions, answers, handleAnswerGiven} = this.props;

        if (R.isNil(currentResult)) {
            const formContent = R.pipe(
                R.map(question => {
                    const props = {
                        key: question.id,
                        value: R.has(question.id, answers) ? answers[question.id] : null,
                        question,
                        handleChange: handleAnswerGiven(question.id)
                    };

                    if (question.is_default) {
                        if (question.id === 'gender') {
                            props.value = R.path(['value'], props.value) || props.value;

                            return (
                                <AnswerStrategy question={question}>
                                    <GenderSelect {...props} />
                                </AnswerStrategy>
                            );
                        }

                        if (question.id === 'age') {
                            return (
                                <AnswerStrategy question={question}>
                                    <AgeEntry {...props} />
                                </AnswerStrategy>
                            );
                        }

                        if (question.id === 'children') {
                            props.value = R.path(['value'], props.value) || props.value;
                            props.onChange = props.handleChange;

                            return (
                                <AnswerStrategy question={question}>
                                    <FormChildren {...props} />
                                </AnswerStrategy>
                            );
                        }
                    }

                    if (question.type === ENUMS.CampaignSmartQuestionType.AGREEMENT) {
                        return (
                            <AnswerStrategy question={question}>
                                <AgreementAnswerer {...props} />
                            </AnswerStrategy>
                        );
                    }
                }),
                R.map(elem => (
                    <span>
                        {elem}
                        <br />
                    </span>
                ))
            )(questions);

            return <span>{formContent}</span>;
        }

        return <div />;
    }
}

export default connect(
    R.pick(['user']),
    {}
)(Form);



// WEBPACK FOOTER //
// ./components/smart_question/form.js